import config from "../../config/config";

const LOGIN_URL = config["backend-url"];
const PENDING_2FA_KEY = "pending_2fa_token";

// ── pending-2FA token helpers (Safari-safe, no cookies needed) ────────────────
export const savePending2faToken = (token) => {
    if (token) sessionStorage.setItem(PENDING_2FA_KEY, token);
};

export const clearPending2faToken = () => {
    sessionStorage.removeItem(PENDING_2FA_KEY);
};

const getPending2faToken = () => sessionStorage.getItem(PENDING_2FA_KEY);

// ── auth endpoints ─────────────────────────────────────────────────────────────

export const verifyEmail = async (email) => {
    const response = await fetch(`${LOGIN_URL}/verify_email`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
    });
    const data = await response.json();
    if (!response.ok) {
        throw new Error(data.error || "Email verification failed");
    }
    return data;
};

export const signIn = async (email, password) => {
    const response = await fetch(`${LOGIN_URL}/sign_in`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ email, password }),
    });
    const data = await response.json();
    if (!response.ok) {
        throw new Error(data.error || "Login failed");
    }
    return data;
};

export const verifyOtp = async (otp) => {
    const response = await fetch(`${LOGIN_URL}/verify_otp`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({ action: "verify", otp, pending_2fa_token: getPending2faToken() }),
    });
    const data = await response.json();
    if (!response.ok) {
        throw new Error(data.error || "OTP verification failed");
    }
    return data;
};

export const resendOtp = async () => {
    const response = await fetch(`${LOGIN_URL}/verify_otp`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({ action: "resend", pending_2fa_token: getPending2faToken() }),
    });
    const data = await response.json();
    if (!response.ok) {
        throw new Error(data.error || "Failed to resend OTP");
    }
    return data;
};

export const forgotPasswordSendMail = async (email) => {
    const response = await fetch(`${LOGIN_URL}/sign_in/forget_password/send_mail`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
    });
    const data = await response.json();
    if (!response.ok) {
        throw new Error(data.error || "Failed to send email");
    }
    return data;
};

export const updatePassword = async (token, newPassword) => {
    const response = await fetch(`${LOGIN_URL}/update_password/${token}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ newPassword }),
    });
    const data = await response.json();
    if (!response.ok) {
        throw new Error(data.error || "Error updating password");
    }
    return data;
};

export const verifySignupEmail = async (email) => {
    const response = await fetch(`${LOGIN_URL}/sign_up/verify_email`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
    });
    const data = await response.json();
    if (!response.ok) {
        throw new Error(data.error || "Email verification failed");
    }
    return data;
};

export const signUp = async (email, password, fullName) => {
    const response = await fetch(`${LOGIN_URL}/sign_up/add_user`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password, fullName }),
    });
    const data = await response.json();
    if (!response.ok) {
        throw new Error(data.error || "Signup failed");
    }
    return data;
};

// ── TOTP (Authenticator App) ──────────────────────────────────────────────────

export const verifyTotp = async (code) => {
    const response = await fetch(`${LOGIN_URL}/totp/verify`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ code, pending_2fa_token: getPending2faToken() }),
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.error || "TOTP verification failed");
    return data;
};

export const setupTotp = async (token) => {
    const headers = { "Content-Type": "application/json" };
    if (token) headers["Authorization"] = `Bearer ${token}`;
    const response = await fetch(`${LOGIN_URL}/totp/setup`, {
        method: "POST",
        headers,
        credentials: "include",
        body: JSON.stringify({ pending_2fa_token: token ? undefined : getPending2faToken() }),
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.error || "Failed to set up TOTP");
    return data;
};

export const confirmTotp = async (token, code) => {
    const headers = { "Content-Type": "application/json" };
    if (token) headers["Authorization"] = `Bearer ${token}`;
    const response = await fetch(`${LOGIN_URL}/totp/confirm`, {
        method: "POST",
        headers,
        credentials: "include",
        body: JSON.stringify({ code, pending_2fa_token: token ? undefined : getPending2faToken() }),
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.error || "Failed to confirm TOTP");
    return data;
};
